import React, { ReactNode } from 'react';
import { Card } from 'antd';
import type { CardProps } from 'antd';

interface EditorCardProps extends CardProps {
  title: ReactNode;
  extra?: ReactNode;
  children: ReactNode;
}

const EditorCard: React.FC<EditorCardProps> = ({ title, extra, children }) => (
  <Card
    title={title}
    extra={extra}
    style={{
      marginBottom: '10px',
      fontWeight: 2,
      marginTop: '10px',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderRadius: '8px',
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)',
      marginLeft: '10px',
      marginRight: '10px',
    }}
    styles={{
      header: {
        backgroundColor: 'var(--color-primary)',
        color: 'white',
        fontWeight: 350,
        fontSize: '14px',
        border: 0,
        borderRadius: '8px 8px 0 0',
        minHeight: '36px',
      },
    }}
  >
    {children}
  </Card>
);

export default EditorCard;